import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card, Button, Table, Form, Input, Tabs, Space, Tag,
  Typography, Alert, Modal, Divider, message
} from 'antd';
import { ArrowLeftOutlined, PlusOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const InvoiceManagePage = () => {
  const navigate = useNavigate();
  const [titleForm] = Form.useForm();
  const [addrForm] = Form.useForm();
  const [titleVisible, setTitleVisible] = useState(false);
  const [titleEditing, setTitleEditing] = useState(false);
  const [addrVisible, setAddrVisible] = useState(false);

  const [titles, setTitles] = useState([
    { key: '1', title: '南京鹤梦信息技术有限公司', taxNo: '91320115MA1TBX9M2Y', bankName: '中国建设银行南京江宁经济开发区支行', bankAccount: '3205 0159 6056 0000 0471', regAddress: '南京市江宁区菲尼克斯路70号总部基地32 栋1001室（江宁开发区）', regPhone: '025-84186339', isDefault: true },
    { key: '2', title: '深圳XXXXX有限公司', taxNo: 'xxxxxxxxxxxxx', bankName: 'xxxxxxxxxx', bankAccount: 'xxxxxxxxx', regAddress: 'xxxxxxx', regPhone: 'xxxxxxx', isDefault: false },
  ]);

  const [addresses, setAddresses] = useState([
    { key: '1', name: '何嘉欣', phone: '86-18851194891', address: '南京市江宁区菲尼克斯路70号总部基地32栋1001室', addedAt: '2025-06-27 23:59:45', isDefault: true },
    { key: '2', name: '曾红玉', phone: '86-13928513086', address: 'XXXXXXXXX', addedAt: '2025-06-22 23:59:45', isDefault: false },
  ]);

  const handleDeleteTitle = (record) => {
    if (record.isDefault) { message.error('默认发票抬头无法被删除，请重试'); return; }
    Modal.confirm({ title: '确定删除该发票抬头么？', okText: '确定', cancelText: '取消', onOk: () => { setTitles(prev => prev.filter(t => t.key !== record.key)); message.success('已删除'); } });
  };

  const handleDeleteAddr = (record) => {
    if (record.isDefault) { message.error('默认地址无法被删除，请重试'); return; }
    Modal.confirm({ title: '确定删除该发票接收地址么？', okText: '确定', cancelText: '取消', onOk: () => { setAddresses(prev => prev.filter(a => a.key !== record.key)); message.success('已删除'); } });
  };

  const titleColumns = [
    { title: '发票抬头', dataIndex: 'title', render: (v, r) => <span>{v} {r.isDefault && <Tag color="blue">默认</Tag>}</span> },
    { title: '纳税人标识号', dataIndex: 'taxNo' },
    { title: '开户银行名称', dataIndex: 'bankName' },
    { title: '开户银行账号', dataIndex: 'bankAccount' },
    { title: '注册场所地址', dataIndex: 'regAddress' },
    { title: '注册固定电话', dataIndex: 'regPhone' },
    {
      title: '操作', key: 'action', width: 200,
      render: (_, r) => (
        <Space size={0} split={<Divider type="vertical" style={{ margin: '0 4px' }} />}>
          <Button type="link" size="small" disabled={r.isDefault} onClick={() => { setTitles(prev => prev.map(t => ({ ...t, isDefault: t.key === r.key }))); message.success('已设为默认'); }}>设为默认</Button>
          <Button type="link" size="small" onClick={() => { setTitleEditing(true); titleForm.setFieldsValue(r); setTitleVisible(true); }}>编辑</Button>
          <Button type="link" size="small" danger onClick={() => handleDeleteTitle(r)}>删除</Button>
        </Space>
      ),
    },
  ];

  const addrColumns = [
    { title: '收件人', dataIndex: 'name', render: (v, r) => <span>{v} {r.isDefault && <Tag color="blue">默认</Tag>}</span> },
    { title: '联系方式', dataIndex: 'phone' },
    { title: '收件地址', dataIndex: 'address' },
    { title: '添加时间', dataIndex: 'addedAt' },
    {
      title: '操作', key: 'action', width: 200,
      render: (_, r) => (
        <Space size={0} split={<Divider type="vertical" style={{ margin: '0 4px' }} />}>
          <Button type="link" size="small" disabled={r.isDefault} onClick={() => { setAddresses(prev => prev.map(a => ({ ...a, isDefault: a.key === r.key }))); message.success('已设为默认'); }}>设为默认</Button>
          <Button type="link" size="small" onClick={() => { addrForm.setFieldsValue(r); setAddrVisible(true); }}>编辑</Button>
          <Button type="link" size="small" danger onClick={() => handleDeleteAddr(r)}>删除</Button>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 12 }}>
        <Button icon={<ArrowLeftOutlined />} type="text" onClick={() => navigate(-1)} />
        <Divider type="vertical" style={{ height: 20, margin: 0 }} />
        <Title level={4} style={{ margin: 0 }}>管理发票信息与接收方式</Title>
      </div>

      <Tabs items={[
        { key: 'info', label: '发票抬头', children: (
          <>
            <Alert type="info" showIcon style={{ marginBottom: 16, borderRadius: 6 }} message={<span><Text style={{ color: '#fa8c16' }}>鹤梦云生态平台的发票抬头</Text>，企业提现/划转给平台开票时，会以此发票抬头信息为开票信息。</span>} />
            <Card bordered={false}>
              <Table columns={titleColumns} dataSource={titles} rowKey="key" pagination={{ showSizeChanger: true, showTotal: (t) => `共${t}条记录` }} />
              <div style={{ textAlign: 'center', marginTop: 8, padding: 16, border: '1px dashed #d9d9d9', borderRadius: 8, cursor: 'pointer' }} onClick={() => { setTitleEditing(false); titleForm.resetFields(); setTitleVisible(true); }}>
                <Button type="link" icon={<PlusOutlined />}>添加发票抬头</Button>
              </div>
            </Card>
          </>
        )},
        { key: 'receive', label: '接收方式', children: (
          <>
            <Alert type="info" showIcon style={{ marginBottom: 16, borderRadius: 6 }} message={<span><Text style={{ color: '#fa8c16' }}>鹤梦云生态平台的收票地址</Text>，企业给平台开纸质发票，会以此作为邮寄地址。</span>} />
            <Card bordered={false}>
              <Title level={5} style={{ marginBottom: 16 }}>邮寄地址</Title>
              <Table columns={addrColumns} dataSource={addresses} rowKey="key" pagination={{ showSizeChanger: true, showQuickJumper: true, showTotal: (t) => `共 ${t} 条` }} />
              <div style={{ textAlign: 'center', marginTop: 8, padding: 16, border: '1px dashed #d9d9d9', borderRadius: 8, cursor: 'pointer' }} onClick={() => { addrForm.resetFields(); setAddrVisible(true); }}>
                <Button type="link" icon={<PlusOutlined />}>添加邮寄地址</Button>
                <Text type="secondary">您最多可添加50个邮寄地址</Text>
              </div>
            </Card>
          </>
        )},
      ]} />

      {/* 添加/修改发票抬头 */}
      <Modal title={titleEditing ? '修改发票抬头' : '添加发票抬头'} open={titleVisible} onCancel={() => setTitleVisible(false)} destroyOnClose width={520}
        onOk={() => { titleForm.validateFields().then(() => { message.success('已保存'); setTitleVisible(false); }); }} okText="确定" cancelText="取消">
        <Form form={titleForm} layout="horizontal" labelCol={{ span: 6 }} wrapperCol={{ span: 17 }} style={{ marginTop: 24 }}>
          <Form.Item label="开具类型" required><Text strong>企业</Text></Form.Item>
          <Form.Item name="title" label="发票抬头" rules={[{ required: true, message: '请输入' }]}><Input placeholder="请输入" /></Form.Item>
          <Form.Item name="taxNo" label="纳税人识别号" rules={[{ required: true, message: '请填写您的纳税人识别号' }]}><Input placeholder="请填写您的纳税人识别号" /></Form.Item>
          <Form.Item name="bankName" label="开户银行名称" rules={[{ required: true, message: '请填写开户许可证上的开户银行' }]}><Input placeholder="请填写开户许可证上的开户银行" /></Form.Item>
          <Form.Item name="bankAccount" label="开户银行账号" rules={[{ required: true, message: '请输入开户许可证上的银行账号' }]}><Input placeholder="请输入开户许可证上的银行账号" /></Form.Item>
          <Form.Item name="regAddress" label="注册场所地址"><Input placeholder="请填写营业执照上的注册地址" /></Form.Item>
          <Form.Item name="regPhone" label="注册固定电话"><Input placeholder="请填写公司有效的联系电话" /></Form.Item>
        </Form>
      </Modal>

      {/* 添加/编辑邮寄地址 */}
      <Modal title="添加邮寄地址" open={addrVisible} onCancel={() => setAddrVisible(false)} destroyOnClose width={480}
        onOk={() => { addrForm.validateFields().then(() => { message.success('已保存'); setAddrVisible(false); }); }} okText="确定" cancelText="取消">
        <Form form={addrForm} layout="horizontal" labelCol={{ span: 5 }} wrapperCol={{ span: 18 }} style={{ marginTop: 24 }}>
          <Form.Item name="name" label="收件人" rules={[{ required: true, message: '请填写发票收件人名称' }]}><Input placeholder="请填写发票收件人名称" /></Form.Item>
          <Form.Item name="phone" label="联系方式" rules={[{ required: true, message: '请填写发票收件人联系方式' }]}><Input placeholder="请填写发票收件人联系方式" /></Form.Item>
          <Form.Item name="address" label="收件地址" rules={[{ required: true, message: '请填写发票收件地址' }]}><Input placeholder="请填写发票收件地址" /></Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default InvoiceManagePage;
